import styled from 'styled-components';


/*
========================================
PÁGINA
========================================
*/

export const PaginaPerfil =
    styled.main`

        width: min(1180px, calc(100% - 40px));

        margin: 0 auto;

        padding: 12px 0 70px;

        color: #646464;

        *,
        *::before,
        *::after {
            box-sizing: border-box;
        }

        @media (max-width: 600px) {

            width: calc(100% - 20px);

            padding: 10px 0 45px;

        }

    `;


export const EncabezadoPagina =
    styled.div`

        margin-bottom: 18px;

    `;


export const DescripcionPagina =
    styled.p`

        margin: 0;

        max-width: 720px;

        color: #646464;

        font-size: 0.92rem;

        line-height: 1.55;

    `;


/*
========================================
MENSAJES
========================================
*/

export const MensajeEstado =
    styled.div`

        margin-bottom:
            18px;

        padding:
            12px 15px;

        border:
            1px solid
            ${
                props =>
                    props.$error
                        ?
                        'rgba(215, 105, 112, 0.28)'
                        :
                        'rgba(35, 170, 175, 0.24)'
            };

        border-radius:
            10px;

        background:
            ${
                props =>
                    props.$error
                        ?
                        'rgba(215, 105, 112, 0.08)'
                        :
                        'rgba(35, 170, 175, 0.07)'
            };

        color:
            ${
                props =>
                    props.$error
                        ?
                        '#D76970'
                        :
                        '#23AAAF'
            };

        font-size:
            0.84rem;

        font-weight:
            650;

        line-height:
            1.45;

    `;


/*
========================================
GRID
========================================
*/

export const GridTarjetas =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            20px;


        @media (
            max-width:
                850px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


/*
========================================
TARJETAS
========================================
*/

export const Tarjeta =
    styled.section`

        min-width:
            0;

        padding:
            24px;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.20
            );

        border-radius:
            16px;

        background:
            #FFFFFF;

        box-shadow:
            0 4px 18px
            rgba(
                0,
                0,
                0,
                0.035
            );


        @media (
            max-width:
                520px
        ) {

            padding:
                19px;

        }

    `;


export const TarjetaAncha =
    styled(Tarjeta)`

        grid-column:
            1 / -1;

    `;


/*
========================================
CABECERA TARJETA
========================================
*/

export const CabeceraTarjeta =
    styled.div`

        display:
            flex;

        align-items:
            flex-start;

        justify-content:
            space-between;

        gap:
            18px;

        margin-bottom:
            22px;


        @media (
            max-width:
                520px
        ) {

            flex-direction:
                column;

            align-items:
                stretch;

        }

    `;


export const BloqueTituloTarjeta =
    styled.div`

        min-width:
            0;

    `;


export const TituloTarjeta =
    styled.h2`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            1.05rem;

        line-height:
            1.3;

        font-weight:
            800;

    `;


export const SubtituloTarjeta =
    styled.p`

        margin:
            5px 0 0;

        color:
            #646464;

        font-size:
            0.79rem;

        line-height:
            1.45;

    `;


/*
========================================
EDITAR
========================================
*/

export const BotonEditarTarjeta =
    styled.button`

        flex:
            0 0 auto;

        min-height:
            36px;

        padding:
            7px 11px;

        display:
            inline-flex;

        align-items:
            center;

        justify-content:
            center;

        gap:
            7px;

        border:
            1px solid
            rgba(
                101,
                94,
                232,
                0.24
            );

        border-radius:
            8px;

        background:
            rgba(
                101,
                94,
                232,
                0.05
            );

        color:
            #655EE8;

        font-family:
            inherit;

        font-size:
            0.76rem;

        font-weight:
            750;

        cursor:
            pointer;

        transition:
            0.16s ease;


        &:hover {

            background:
                rgba(
                    101,
                    94,
                    232,
                    0.10
                );

        }


        @media (
            max-width:
                520px
        ) {

            align-self:
                flex-start;

        }

    `;


export const IconoBoton =
    styled.img`

        width:
            14px;

        height:
            14px;

        object-fit:
            contain;

    `;


/*
========================================
DATOS
========================================
*/

export const DatosGrid =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            12px;


        @media (
            max-width:
                520px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


export const DatoBloque =
    styled.div`

        min-width:
            0;

        padding:
            12px 13px;

        border-radius:
            10px;

        background:
            #F7FAFA;


        ${
            props =>
                props.$completo
                    ?
                    `
                        grid-column:
                            1 / -1;
                    `
                    :
                    ''
        }

    `;


export const EtiquetaDato =
    styled.div`

        margin-bottom:
            5px;

        color:
            #23AAAF;

        font-size:
            0.72rem;

        font-weight:
            800;

        text-transform:
            uppercase;

        letter-spacing:
            0.025em;

    `;


export const ValorDato =
    styled.div`

        overflow-wrap:
            anywhere;

        color:
            ${
                props =>
                    props.$destacado
                        ?
                        '#444444'
                        :
                        '#646464'
            };

        font-size:
            ${
                props =>
                    props.$destacado
                        ?
                        '0.95rem'
                        :
                        '0.86rem'
            };

        font-weight:
            ${
                props =>
                    props.$destacado
                        ?
                        '650'
                        :
                        '500'
            };

        line-height:
            1.45;

    `;


/*
========================================
PANEL EDICIÓN
========================================
*/

export const PanelEdicion =
    styled.div`

        grid-column:
            1 / -1;

        width:
            100%;

        padding:
            22px;

        border:
            1px solid
            rgba(
                101,
                94,
                232,
                0.16
            );

        border-radius:
            13px;

        background:
            #FCFCFE;


        @media (
            max-width:
                520px
        ) {

            padding:
                17px;

        }

    `;


export const TituloPanelEdicion =
    styled.h3`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            0.98rem;

        font-weight:
            800;

        line-height:
            1.3;

    `;


/*
========================================
CAMPOS
========================================
*/

export const GridCampos =
    styled.div`

        display:
            grid;

        grid-template-columns:
            ${
                props =>
                    props.$unaColumna
                        ?
                        '1fr'
                        :
                        `
                            repeat(
                                2,
                                minmax(
                                    0,
                                    1fr
                                )
                            )
                        `
            };

        gap:
            15px 17px;


        @media (
            max-width:
                650px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


export const Campo =
    styled.div`

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        gap:
            6px;

    `;


export const LabelCampo =
    styled.label`

        color:
            #646464;

        font-size:
            0.76rem;

        font-weight:
            750;

    `;


export const InputCampo =
    styled.input`

        width:
            100%;

        min-height:
            43px;

        padding:
            10px 12px;

        border:
            1.5px solid
            rgba(
                35,
                170,
                175,
                0.28
            );

        border-radius:
            9px;

        outline:
            none;

        background:
            #FFFFFF;

        color:
            #646464;

        font-family:
            inherit;

        font-size:
            0.86rem;

        transition:
            0.16s ease;


        &:focus {

            border-color:
                #23AAAF;

            box-shadow:
                0 0 0 3px
                rgba(
                    35,
                    170,
                    175,
                    0.08
                );

        }

    `;


/*
========================================
DROPDOWNS LEGACY
========================================

Los dropdowns que no son geográficos
siguen usando useSelectDropwdown.

Los envolvemos para integrarlos
visualmente sin tocar ese hook ahora.
========================================
*/

export const CampoSelectLegacy =
    styled.div`

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        gap:
            6px;


        select {

            width:
                100% !important;

            min-height:
                43px !important;

            padding:
                8px 10px !important;

            border:
                1.5px solid
                rgba(
                    35,
                    170,
                    175,
                    0.28
                ) !important;

            border-radius:
                9px !important;

            outline:
                none !important;

            background:
                #FFFFFF !important;

            color:
                #646464 !important;

            font-family:
                inherit !important;

            font-size:
                0.86rem !important;

        }


        select:focus {

            border-color:
                #23AAAF !important;

        }


        label {

            color:
                #646464;

            font-size:
                0.76rem;

            font-weight:
                750;

        }

    `;


/*
========================================
AYUDAS / ERRORES
========================================
*/

export const TextoAyuda =
    styled.p`

        margin:
            13px 0 0;

        color:
            #646464;

        font-size:
            0.76rem;

        line-height:
            1.5;

    `;


export const TextoError =
    styled.div`

        margin-top:
            7px;

        color:
            #D76970;

        font-size:
            0.76rem;

        font-weight:
            650;

        line-height:
            1.4;

    `;


/*
========================================
UBICACIÓN
========================================
*/

export const BloqueUbicacion =
    styled.div`

        margin-top:
            16px;

        padding:
            17px;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.18
            );

        border-radius:
            11px;

        background:
            rgba(
                35,
                170,
                175,
                0.025
            );


        @media (
            max-width:
                520px
        ) {

            padding:
                13px;

        }

    `;


export const AvisoLegacy =
    styled.div`

        margin-top:
            14px;

        padding:
            12px 14px;

        border:
            1px solid
            rgba(
                239,
                195,
                64,
                0.34
            );

        border-radius:
            9px;

        background:
            rgba(
                239,
                195,
                64,
                0.08
            );

        color:
            #646464;

        font-size:
            0.77rem;

        line-height:
            1.5;

    `;


/*
========================================
SEPARADOR
========================================
*/

export const Separador =
    styled.div`

        width:
            100%;

        height:
            1px;

        margin:
            22px 0;

        background:
            rgba(
                100,
                100,
                100,
                0.11
            );

    `;


/*
========================================
ACCIONES
========================================
*/

export const FilaAcciones =
    styled.div`

        margin-top:
            20px;

        display:
            flex;

        flex-wrap:
            wrap;

        justify-content:
            ${
                props =>
                    props.$izquierda
                        ?
                        'flex-start'
                        :
                        'flex-end'
            };

        gap:
            9px;


        @media (
            max-width:
                520px
        ) {

            button {

                flex:
                    1 1 auto;

            }

        }

    `;


const botonBase = `

    min-height:
        39px;

    padding:
        8px 14px;

    border-radius:
        8px;

    font-family:
        inherit;

    font-size:
        0.78rem;

    font-weight:
        750;

    cursor:
        pointer;

    transition:
        0.16s ease;

`;


export const BotonPrimario =
    styled.button`

        ${botonBase}

        border:
            1px solid
            #FC8906;

        background:
            #FC8906;

        color:
            #FFFFFF;


        &:hover {

            box-shadow:
                0 4px 12px
                rgba(
                    252,
                    137,
                    6,
                    0.20
                );

            transform:
                translateY(
                    -1px
                );

        }

    `;


export const BotonSecundario =
    styled.button`

        ${botonBase}

        border:
            1px solid
            rgba(
                101,
                94,
                232,
                0.28
            );

        background:
            #FFFFFF;

        color:
            #655EE8;


        &:hover {

            background:
                rgba(
                    101,
                    94,
                    232,
                    0.06
                );

        }

    `;


export const BotonPeligro =
    styled.button`

        ${botonBase}

        border:
            1px solid
            rgba(
                215,
                105,
                112,
                0.30
            );

        background:
            rgba(
                215,
                105,
                112,
                0.05
            );

        color:
            #D76970;


        &:hover {

            background:
                rgba(
                    215,
                    105,
                    112,
                    0.10
                );

        }

    `;


/*
========================================
SEGURIDAD
========================================
*/

export const SeguridadAcciones =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            11px;


        @media (
            max-width:
                520px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


export const BotonSeguridad =
    styled.button`

        min-height:
            48px;

        padding:
            10px 13px;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.23
            );

        border-radius:
            10px;

        background:
            #F7FAFA;

        color:
            #23AAAF;

        font-family:
            inherit;

        font-size:
            0.82rem;

        font-weight:
            750;

        cursor:
            pointer;

        transition:
            0.16s ease;


        &:hover {

            background:
                rgba(
                    35,
                    170,
                    175,
                    0.09
                );

        }

    `;


/*
========================================
CONSULTORIOS
========================================
*/

export const ListaConsultorios =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            14px;


        @media (
            max-width:
                760px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


export const TarjetaConsultorio =
    styled.div`

        min-width:
            0;

        padding:
            16px;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.17
            );

        border-radius:
            11px;

        background:
            #FAFCFC;

    `;


export const CabeceraConsultorio =
    styled.div`

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            12px;

        margin-bottom:
            12px;

    `;


export const NombreConsultorio =
    styled.div`

        color:
            #444444;

        font-size:
            0.93rem;

        font-weight:
            800;

    `;


export const BadgeDefault =
    styled.span`

        flex:
            0 0 auto;

        display:
            inline-flex;

        align-items:
            center;

        justify-content:
            center;

        padding:
            5px 9px;

        border-radius:
            999px;

        background:
            rgba(
                35,
                170,
                175,
                0.12
            );

        color:
            #23AAAF;

        font-size:
            0.67rem;

        font-weight:
            800;

        text-transform:
            uppercase;

    `;


export const DatosConsultorio =
    styled.div`

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            8px;


        @media (
            max-width:
                520px
        ) {

            grid-template-columns:
                1fr;

        }

    `;


export const AccionesConsultorio =
    styled.div`

        margin-top:
            13px;

        display:
            flex;

        flex-wrap:
            wrap;

        justify-content:
            flex-end;

        gap:
            7px;

    `;


export const EstadoVacio =
    styled.div`

        padding:
            24px;

        border:
            1px dashed
            rgba(
                35,
                170,
                175,
                0.28
            );

        border-radius:
            11px;

        background:
            rgba(
                35,
                170,
                175,
                0.025
            );

        color:
            #646464;

        text-align:
            center;

        font-size:
            0.82rem;

        line-height:
            1.55;

    `;


/*
========================================
CHECKBOX
========================================
*/

export const FilaCheckbox =
    styled.label`

        margin-top:
            17px;

        display:
            flex;

        align-items:
            center;

        gap:
            8px;

        color:
            #646464;

        font-size:
            0.79rem;

        cursor:
            pointer;

    `;


export const Checkbox =
    styled.input`

        width:
            17px;

        height:
            17px;

        accent-color:
            #23AAAF;

        cursor:
            pointer;

    `;